import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

import ProgressWidget from 'src/components/widgets/ProgressWidget';
import SnakbarAlert from 'src/components/widgets/SnakbarAlert';
// import IntroMessage from 'src/components/IntroMessage';
import withErrorBoundary from 'src/hocs/withErrorBoundary';
import SystemNotification from 'src/components/widgets/SystemNotification';

import NavBar from './NavBar';

const styles = {
  root: {
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: (bannerHeight) => ({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: `${bannerHeight}px`
  })
};

const DashboardLayout = () => {
  const [bannerHeight, setBannerHeight] = useState(0);

  return (
    <>
      <Box sx={styles.root}>
        <SystemNotification setBannerHeight={setBannerHeight} />
        <NavBar bannerHeight={bannerHeight} />
        <Box sx={styles.wrapper(bannerHeight)}>
          <Outlet />
        </Box>
      </Box>
      <ProgressWidget />
      <SnakbarAlert />
      {/* <IntroMessage setMobileNavOpen={() => {}} /> */}
    </>
  );
};

export default withErrorBoundary(DashboardLayout);
